(function () {

    "use strict";

    angular.module("parLabor", [
        'formsManager',
        'apiManager'
    ]);
})();